import React from "react";
import { BarChart3 } from "lucide-react";

// GoFood Truck Financial Ratios Data
const FinancialRatiosData = [
  { category: "Category", values: ["2022", "2023", "2024"], bold: true, isHeader: true },
  
  // Revenue Breakdown
  { category: "Food Truck Sales", values: ["75.0%", "78.0%", "73.0%"], bold: false },
  { category: " Hotdogs", values: ["12.0%", "10.0%", "11.0%"], bold: false },
  { category: " Hamburgers", values: ["18.0%", "20.0%", "17.0%"], bold: false },
  { category: " Fries", values: ["14.0%", "13.0%", "15.0%"], bold: false },
  { category: " Tacos", values: ["12.0%", "13.0%", "13.0%"], bold: false },
  { category: " Beverages", values: ["19.0%", "22.0%", "17.0%"], bold: false },
  { category: "Catering Services", values: ["18.0%", "14.0%", "20.0%"], bold: false },
  { category: "Other Revenue", values: ["7.0%", "8.0%", "7.0%"], bold: false },
  { category: "Total Revenue", values: ["100.0%", "100.0%", "100.0%"], bold: true },
  
  // Cost Breakdown
  { category: "Food Ingredient Costs", values: ["50.0%", "51.0%", "50.0%"], bold: false },
  { category: " Meat and Buns", values: ["30.0%", "31.0%", "30.0%"], bold: false },
  { category: " Vegetables & Condiments", values: ["10.0%", "10.0%", "10.0%"], bold: false },
  { category: " Packaging", values: ["10.0%", "10.0%", "10.0%"], bold: false },
  { category: "Beverage Costs", values: ["20.0%", "19.0%", "20.0%"], bold: false },
  { category: "Catering Supply Costs", values: ["15.0%", "13.0%", "15.0%"], bold: false },
  { category: "Other Costs", values: ["5.0%", "7.0%", "5.0%"], bold: false },
  { category: "Total COGS", values: ["40.0%", "40.0%", "40.0%"], bold: true },
  
  // Profitability
  { category: "Gross Profit Margin", values: ["60.0%", "60.0%", "60.0%"], bold: true },
  
  // Operating Expenses
  { category: "Operating Expenses", values: ["35.0%", "34.0%", "33.0%"], bold: false },
  { category: " Staff Wages", values: ["19.0%", "18.0%", "17.5%"], bold: false },
  { category: " Truck Maintenance", values: ["8.5%", "8.0%", "8.5%"], bold: false },
  { category: " Fuel Costs", values: ["4.0%", "4.0%", "4.5%"], bold: false },
  { category: " Utilities", values: ["2.5%", "3.0%", "3.5%"], bold: false },
  { category: " Marketing & Promotions", values: ["4.5%", "5.0%", "4.5%"], bold: false },
  { category: " Administrative Expenses", values: ["7.5%", "7.0%", "6.5%"], bold: false },
  { category: "Total Expenses", values: ["74.4%", "74.1%", "73.5%"], bold: true },
  
  // Financial Ratios
  { category: "Total Operating Income", values: ["21.1%", "21.6%", "22.3%"], bold: true },
  { category: "Other Income", values: ["0.9%", "1.0%", "1.1%"], bold: false },
  { category: "Earnings Before Tax", values: ["20.8%", "21.4%", "22.1%"], bold: true },
  { category: "Earnings Before Interest & Taxes", values: ["21.1%", "21.6%", "22.3%"], bold: true },
  { category: "EBITDA", values: ["25.6%", "25.9%", "26.5%"], bold: true }
];

// Financial Statement Ratios Component
const FinancialStatementRatios = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">Income Statement Ratios</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Financial Ratios (Last 3 Years) – Percentages reflect revenue distribution and expenses.
      </p>

      {/* Financial Ratios Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Category</th>
              {FinancialRatiosData[0].values.map((year, index) => (
                <th key={index} className="border border-gray-300 px-4 py-2 text-center font-semibold">
                  {year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {FinancialRatiosData.slice(1).map((item, index) => (
              <tr key={index} className="border-b border-gray-300">
                <td className={`border border-gray-300 px-4 py-2 ${item.bold ? "font-bold" : ""}`}>
                  {item.category}
                </td>
                {item.values.map((value, i) => (
                  <td key={i} className="border border-gray-300 px-4 py-2 text-center">
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FinancialStatementRatios;
